<!--  -->
<template>
  <div class="container">
      <login-navigator></login-navigator>
      <logo-header></logo-header>
      <section class="main">
        <main-navigator :currentIndex="currentIndex"></main-navigator>
        <section class="main-content center">
          <div class="left">
            <div class="banner-content">
              <img src="../assets/banner.jpg" alt=""> 
            </div>
          </div>
          <div class="right">
            <h3>热点资讯</h3>
            <ul>
                <li v-for="(item,index) in newsList"><router-link :to="{path:'news',query:{id:index}}">{{item.pList[0]}}</router-link></li>
            </ul>
            <div class="more"><router-link to="/more"><span>更多资讯&gt;</span></router-link></div>
          </div>
        </section>
        <section class="recommend-wrap">
          <h4>推荐信息</h4>
          <ul>
            <li class="item" v-for="item in  recommend">
              <div class="left">
                <img :src="item.thumb_img" alt="">
              </div>
              <div class="right">
                <div class="des">
                  <h3>{{item.title}}</h3>
                  <span class="price">{{item.price}}</span>
                  <span class="recruit">{{item.address}}</span>
                </div>
                <router-link :to="{path:'detail',query:{id:item.id,navid:1,navindex:0}}"><span class="enroll">报名</span></router-link>
              </div>
            </li>
          </ul>
        </section>
      </section>  
  </div>
</template>

<script>
import LoginNavigator from "@/components/LoginNavigator";
import LogoHeader from "@/components/LogoHeader";
import MainNavigator from "@/components/MainNavigator";
import qs from "qs";
export default {
  data() {
    return {
      navList: [
        "教育培训",
        "全职招聘",
        "房屋租售",
        "兼职招聘",
        "求职简历",
        "交友活动",
        "宠物",
        "生活服务",
        "车辆买卖服务",
        "二手物品"
      ],
      newsList: [
        {
          title: "年轻人排队买的这款高性能、高颜值、高安全轿车，你买了吗?",
          time: "2017-3-23",
          pList: [
            "实践是检验整理的唯一标准，市场是检验一辆车好坏的不二法门。全新名爵6仅上市4个多月，变成为运动轿车市场的新巨头，年轻人都排队买了。并且，作为互联网性能座驾，其互联网版本占比超70%，追求性能的年轻人，同时也乐意享受互联网新生活，这一切，全新名爵6都能满足。但是，这就够了吗?",
            "显然是不够的，作为有着近百年竞速历史、崇尚Safety Fast的MG名爵，不仅快，也不仅融入网联基因，更难得的是“快而稳”。刚刚上市的全新名爵6 20T自动Trophy超级运动互联网版，就越级配备了MG PILOT智能主动驾驶辅助系统，并以满分成绩通过中国首次公开模拟真实交通路况的主动安全测试，回应年轻人“快即正义”的诉求。",
            "在全新名爵6刚亮相时，各种溢美言辞，让全新名爵6突然就火了，全新名爵6上市就被称为“感性力颜王”，“感性力颜王”一词，原来是说名爵6的。还有说其是“这一抹红，专为“真”运动时尚范儿而来”。可以说，全新名爵6做到了精准回应消费升级时代年轻消费者的高品质驾乘需求，自上市以来大热不止，是年轻人口中好看又好开的“高性能运动轿车本车”。",
            "世代都在为运动而生，全新名爵6自然不会差。凭借6秒级动力总成，百公里加速仅需6.6秒，名爵6搭载了一台搭载了“蓝芯高效动力科技”的1.5T涡轮增压发动机，动力达到了169马力，扭矩为250牛米，比思域的最大扭矩还大30牛米。",
            "爱玩爱浪、精力不限额的年轻人，有车以后活动半径更加大，对汽车的高性能和高安全性有更高追求。给年轻人“快而稳”的驾乘体验，是MG名爵一直以来坚持Safety Fast的体现。因此，全新名爵6在高性能的年轻激情驾控体验之外，于3月新添全新名爵6 20T自动Trophy超级运动互联网版，并领先思域、昂克赛拉等同级产品，“超前”主动单挑同步全球最高标准的主动安全测试，更进一步为年轻人提供最极致的安全保障。"
          ]
        },
        {
          title: "人工智能异军突起，中小学如何接招",
          time: "2018-04-04",
          pList: [
            "随着信息技术的发展，人工智能融入社会各行业和百姓生活中，中小学也掀起了一波“人工智能热”。今年两会期间，多位代表委员提出与人工智能相关的议案、提案，建议发展教育科技。“人工智能+教育”的话题日渐成为中小学校长和教育专家讨论的焦点。那么，人工智能进校园，会给中小学教育带来哪些机遇和挑战？",
            "科技信息素养是信息时代最基本的生存能力，在不少国家，科技信息技术教育已经上升到国家层面，英国、美国、澳大利亚等国家都对信息化技术制定了相应的课程标准。如，英国在2013年发布国家计算课程标准；美国则在2016年由计算机科学教师协会研制了“K-12计算机科学课程标准”等。",
            "2017年5月，国务院印发《新一代人工智能发展规划》（以下简称《规划》）提出,实施全民智能教育项目，在中小学校设置人工智能课程，推广编程教育，鼓励社会力量参与寓教于乐的编程教学软件、游戏的开发和推广，支持开展人工智能竞赛，鼓励进行形式多样的人工智能科普创作，鼓励科学家参与人工智能科普。教育部最新发布的高中新课程方案和课程标准，也将人工智能、物联网、大数据处理等内容列入其中。",
            "通过科技教育提升学生科技信息素养，成为学校培养未来社会人才的重要支点。在十三届全国人大一次会议新闻中心举办的记者会上，教育部部长陈宝生曾说道：“人工智能等异军突起，引起各方面的高度关注。这都要求我们对人才培养的模式进行改革、进行创新。这样我们才能培养起承担民族复兴大任一代新人的历史任务。”",
            "随着新技术的更新迭代，科技教育的形式也不断创新。北京大学教育学院教育技术系主任尚俊杰认为，促进科技教育的最好方法是“用科技”，人工智能的崛起，让科技教育如虎添翼。“不难看到，游戏化、VR（虚拟现实）、AR（增强现实）等科技技术在科技教育中的使用都增强了学生的上课体验与使用效果。”"
          ]
        },
        {
          title: "生态环境部向京津等二十市发督办函 要求公开问题清单",
          time: "2018-04-05",
          pList: [
            "法制网讯　记者郄建荣 京津冀大气污染传输通道城市即“2＋26”城市为期一年的强化督查已经结束，生态环境部近日向北京、天津等20个市政府发出组建后首批督办函，同时移交了督办问题清单。生态环境部要求收到督办问题后2个工作日内公开信息，否则或将量化问责。",
            "生态环境部向20个市政府发出督办函，要求地方政府高度重视督办问题整改落实工作，进一步调查核实有关情况，加大工作力度，严格规范要求，确保督办的各类问题按要求完成整改。",
            "对督办后仍推进缓慢的，整改落实不到位的，应当立案处罚而未处罚的，虚报、瞒报问题突出的，未按《信息公开方案》要求公开相关信息的，以及其他纳入量化问责情形范围的，生态环境部将依照《京津冀及周边地区2017－2018年秋冬季大气污染综合治理攻坚行动量化问责规定》提出问责建议。"
          ]
        },
        {
          title: "中国便利店行业连续7年增长 苏宁收购迪亚抢占风口",
          time: "2018-04-05",
          pList: [
            "4月3日晚间，迪亚天天发布公告称，就出售迪亚中国 股权事项，公司已与苏宁签订了有约束力的购买与出售协议。据悉，在获得政府部门的审批并完成收购之后，苏宁易购将输出智慧零售解决方案，对后者进行多方面的赋能与升级，加速苏宁小店在上海地区的布局和落地。",
            "对于此项收购，苏宁零售集团副总裁卞农表示，迪亚在上海拥有约250万会员，有超过300家门店密集布于上海主城区，且基本均处于社区商圈，与苏宁小店的社区定位一致，该类门店网络具备稀缺性，一次性获取可大幅减少苏宁的时间成本和资源投入。另一方面，迪亚中国有相对成熟的运营体系，也将助力苏宁小店快速切入上海市场。",
            "完成收购之后，苏宁将输出智慧零售模式，整合苏宁线下线上融合的服务能力、苏宁八大产业会员资源，及其在互联网大数据营销方面的优势，协同提升其运营效率，将苏宁小店快速推广到上海各个社区，为用户随时随地提供 的购物体验。",
            "据悉，苏宁与迪亚国际还拟商讨开展在进出口商品与供应链方面的战略合作，资源互补，利用迪亚国际的海外供应链资源和苏宁在中国市场的渠道优势，苏宁可以为迪亚国际的供应商在中国提供分销渠道及定制服务，迪亚国际为苏宁引进欧洲的优质产品，并将为中国优质产品拓展国际市场提供服务。",
            "对于苏宁而言，收购迪亚仅仅只是开始，它是快速推进苏宁小店在全国重点城市布局，建立本地化的商品供应链体系，进一步丰富苏宁智慧零售经营场景的一次重要举措。就在此前的3月31日这天，133家苏宁小店在43座城市开业。",
            "苏宁小店是苏宁易购集团在“社区O2O”领域的新尝试，采用“便利店+App”模式，由实体门店和独立App结合而成。和传统便利店主打快消品不同的是，苏宁小店向消费者提供以快消和生鲜为代表的全品类商品和1公里范围内 快30分钟急速配送的服务，以及家电维修、家电清洗、家政、快递代收等便民社区服务，主要满足区域消费者在 后一公里对购物、餐饮、闪送等生活购物和日常服务的需求，尤其要解决周边消费者的一日三餐。",
            "据《2017中国便利店发展报告》数据显示，中国连锁品牌化便利店门店数接近10万家，销售达1300亿。从2010年起连续7年的时间里，中国便利店行业销售额一直保持两位数增长，且从2011年起，就超越了百货和超市等其他零售业态的增速。",
            "而苏宁在这方面有着先天的优势。在O2O商业零售领域有着28年积累的苏宁，从2017年开始布局社区商业生态，“基于乐观预测，未来三年，我们将成为中国 的O2O社区小店运营商，让原来的社区小店插上互联网的翅膀。”苏宁零售集团副总裁卞农今年3月的一个发布会上，向行业阐述了小店的定位和目标。"
          ]
        },
        {
          title: "新规！5月1日起高铁上吸烟者将禁止乘坐火车",
          time: "2018-04-05",
          pList: [
            "5月1日起，两部与市民出行相关的新规将开始实施，对火车逃票、违规吸烟、机场闹事等交通出行失信行为的处罚加码。根据新规，在动车组列车或其他列车的禁烟区域内吸烟，将被处以180天内禁止乘坐火车，而在机场、飞机上的“闹事者”也将被给予一年内禁止乘坐飞机的处罚。",
            "3月中旬，国家发改委等部门联合下发《关于在一定期限内适当限制特定严重失信人乘坐火车推动社会信用体系建设的意见》和《关于在一定期限内适当限制特定严重失信人乘坐民用航空器推动社会信用体系建设的意见》。",
            "重案组37号(微信ID：zhonganzu37)发现，两份规定并非首次针对“交通不文明”现象亮剑，早在2017年1月，国家发改委、交通运输部、公安部、民航局、铁路总公司等5部门就曾联合发布《关于加强交通出行领域信用建设的指导意见》(简称《意见》)，建议对交通失信行为实施联合惩戒，使交通领域不文明行为与其他领域的信用情况“挂钩”"
          ]
        }
      ],
      currentIndex: 0,
      recommend: [
        {
          id: "1",
          title: "广东最好的早茶点心培训机构，天河区指定早茶培训点",
          price: "4880.00 元",
          address: "广州市天河区龙洞迎龙路194号（九龙城对面）",
          thumb_img:
            "http://oss.huangye88.net/live/user/1488633/1472991644073132900-0.jpg@1e_1c_114w_76h_90Q"
        },
        {
          id: "2",
          title: "无锡广益叉车培训博奥职业培训学校",
          price: "1200.00元",
          address: "无锡新区坊前新东坊商业街19号205",
          thumb_img:
            "http://oss6.huangye88.net/2014/03/15/9503e04fc94dbc31.jpg@1e_1c_220w_220h_90Q"
        }
      ]
    };
  },
  components: {
    LoginNavigator,
    LogoHeader,
    MainNavigator
  },
  mounted() {},
  methods: {}
};
</script>
<style scoped>
@import url("../assets/css/reset.css");
.container {
  background: #f5f5f5;
}
.main {
  width: 100%;
}
.center {
  width: 1200px;
  margin: 0 auto;
}
.main .main-content {
  display: flex;
}
.main .main-content .left {
  background: #fff;
}
.main .main-content .left .banner-content {
  padding: 20px 10px;
}
.main .main-content .left img {
  width: 900px;
  height: 400px;
}
.main .main-content .right {
  width: 100%;
  background: #fff;
}
.main .main-content .right h3 {
  font-size: 21px;
  color: #333;
  padding: 24px 0 26px 20px;
}
.main .main-content .right ul {
}
.main .main-content .right ul li {
  width: 270px;
  height: 40px;
  padding: 0 10px;
  box-sizing: border-box;
  margin-top: 30px;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.main .main-content .right ul > li:first-child {
  margin-top: 0;
}
.main .main-content .right .more {
  padding-right: 30px;
  text-align: right;
  line-height: 60px;
}
.main .main-content .right .more span {
  color: #999;
  font-size: 16px;
}
.recommend-wrap {
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;
}
.recommend-wrap h4 {
  font-size: 21px;
  color: #333;
  padding: 28px 0 30px 20px;
}
.recommend-wrap .item {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #f2f4f5;
}
.recommend-wrap .left {
  padding: 10px 17px 10px 9px;
}
.recommend-wrap .left img {
  display: inline-block;
  width: 160px;
  height: 100px;
  background: #f2f4f5;
}
.recommend-wrap .right {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.recommend-wrap .right .des {
  display: flex;
  flex-direction: column;
}
.recommend-wrap .right .des .name {
  font-size: 16px;
  color: #333;
}
.recommend-wrap .right .des .price {
  font-size: 14px;
  color: #ff7e00;
  margin-top: 8px;
}
.recommend-wrap .right .des .recruit {
  font-size: 12px;
  color: #b3b3b3;
  margin: 8px 0;
}
.recommend-wrap .right .des p .tag {
  display: inline-block;
  width: 70px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 11px;
  background: #f2f4f5;
  color: #c2c8cc;
  margin-right: 12px;
}
.recommend-wrap .right .enroll {
  display: inline-block;
  width: 110px;
  height: 40px;
  font-size: 18px;
  line-height: 40px;
  text-align: center;
  background: #00a0e9;
  color: #fff;
  margin-right: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue